import type { StartupDocumentData } from '@workspace/api-backend'
import { Button } from '@workspace/ui/components/button'
import { EmptyState } from '@workspace/ui/components/empty-state'
import { formatDate, formatFileSize } from '@workspace/ui/lib/utils'
import { Eye, FileText } from 'lucide-react'

export type DocumentsListProps = {
  documents: StartupDocumentData[]
  onPreview: (doc: StartupDocumentData) => void
}

export function DocumentsList({ documents, onPreview }: DocumentsListProps) {
  if (documents.length === 0) {
    return <EmptyState icon={<FileText className="size-8" />} title="No documents uploaded" />
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className="flex items-center justify-between p-4 rounded-lg border border-border bg-card"
        >
          <div className="flex items-center gap-3 min-w-0">
            <FileText className="size-8 text-muted-foreground shrink-0" />
            <div className="min-w-0">
              <p className="font-medium text-sm truncate">{doc.label || doc.document.fileName}</p>
              <p className="text-xs text-muted-foreground">
                {doc.document.fileSize && formatFileSize(doc.document.fileSize)}
                {doc.document.fileSize && doc.document.createdAt && ' · '}
                {doc.document.createdAt && formatDate(doc.document.createdAt, { month: 'short' })}
              </p>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={() => onPreview(doc)}>
            <Eye className="size-4" />
            Preview
          </Button>
        </div>
      ))}
    </div>
  )
}
